import { Component, OnInit, Inject } from '@angular/core';
import {EntityRawMaterialsDtoExtended} from '@root/user/src/app/view/neq/pages/rawmaterials/rawmaterials-list.page';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  templateUrl: './rawmaterials-confirmation-popin.component.html',
})
export class NeqRawMaterialsConfirmationPopinComponent implements OnInit {

  message: string;
  entities: EntityRawMaterialsDtoExtended[];

  constructor(
    private readonly dialogRef: MatDialogRef<NeqRawMaterialsConfirmationPopinComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      message: string,
      rawMaterials: EntityRawMaterialsDtoExtended[]
    }
  ) {
  }

  ngOnInit() {
    if (this.data) {
      if (this.data.message) {
        this.message = this.data.message;
      }
      if (this.data.rawMaterials) {
        this.entities = this.data.rawMaterials;
      }
    }
  }

  continue() {
    this.dialogRef.close(true);
  }

  goBack() {
    this.dialogRef.close(false);
  }
}
